import { dbIdLength, tsValidateArray, tsValidateId, tsValidateIsInRange, tsValidateRegexp, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
const synonymRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\d\-+,:.&%/(){}\[\]<>!?'" ]{1,100}$/;
const Validator_ModifiableProps = {
    synonyms: tsValidateArray(tsValidateRegexp(synonymRegex)),
    phrases: tsValidateArray(tsValidateString(), false),
    keywords: tsValidateArray({ label: tsValidateString(), score: tsValidateIsInRange([[-1, 1]]) }, false),
    corpus: tsValidateArray({ label: tsValidateString(), options: tsValidateArray(tsValidateString()) }, false),
    _rowId: tsValidateId(dbIdLength, false),
};
const Validator_GeneratedProps = {};
export const DBDef_NLPData = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1'],
    dbKey: 'nlp-data',
    entityName: 'NLPData',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'nlp-data'
    },
    backend: {
        name: 'nlp-data'
    },
    metadata: {
        synonyms: {
            optional: false,
            description: '',
            valueType: 'string[]',
            metadata: { optional: false, description: 'Array of synonyms to this data', valueType: 'string' }
        },
        phrases: {
            optional: false,
            description: '',
            valueType: 'string[]',
            metadata: { optional: true, description: '', valueType: 'string' }
        },
        keywords: {
            optional: false,
            description: '',
            valueType: 'object[]',
            metadata: {
                label: { optional: false, description: '', valueType: 'string' },
                score: { optional: false, description: '1 / 0 / -1', valueType: 'number' }
            }
        },
        corpus: {
            optional: false,
            description: '',
            valueType: 'object[]',
            metadata: {
                label: { optional: false, valueType: 'string', description: '' },
                options: {
                    optional: false,
                    description: '',
                    valueType: 'string[]',
                    metadata: { optional: false, description: '', valueType: 'string' }
                }
            }
        },
        _rowId: { optional: true, description: 'exists only for excel-origin objects', valueType: 'string' },
    },
};
//# sourceMappingURL=db-def.js.map